import React, { useState, useEffect, useContext } from 'react';
// import '../assets/style.css';
// import '../assets/css/index.css';
// import '../assets/css/grid.css';
// import '../assets/css/theme.css';

// import '../assets/boxicons-2.0.7/css/boxicons.min.css';
import useSound from 'use-sound';
import { Link } from 'react-router-dom';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import NewQuestionBox from '../NewQuestionBox';
import ImagewithTextField from '../ImagewithTextField';
import TexttoSpeechwithTextfield from '../TexttoSpeechwithTextfield';
import QuestionswithTextField from '../QuestionswithTextField';
import ImagewithRadio from '../ImagewithRadio';
import CorrectAnswers from '../CorrectAnswers';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../UserContext';
import { useLocation } from 'react-router';
import { default as animationData1 } from '../../assets/congratulations.json';
import { default as animationData2 } from '../../assets/tryagain.json';

import { cx } from '@emotion/css';
import { button } from '../../styles/components/buttons.style';
import * as styles from '../quizApp.style';
import Confetti from 'react-confetti';

Amplify.configure(config);

const MOTIVATION_COMEBACK = "Great effort! You've reviewed some mistakes today. Come back tomorrow for more practice!";
const MOTIVATION_CONTINUE = "Awesome! You've corrected all your mistakes. Keep up the good work and continue practicing!";

function PremiumQuiz(props) {
  const [questionBank, set_questionBank] = useState([]);
  const [score, set_score] = useState(0);
  const [username, set_username] = useState('');
  const [useremail, set_useremail] = useState('');
  const [wrongansweredquestions, set_wrongansweredquestions] = useState([]);
  const [limitReached, set_limitReached] = useState(false);
  const [timerKey, set_timerKey] = useState(0);
  const [event_activity_answers, set_event_activity_answers] = useState({});

  const incrementScore = () => set_score(score + 1);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [useranswer, set_useranswer] = useState('');
  const [totalquestions, set_totalquestions] = useState(0);
  const [finished, is_finished] = useState(false);
  const [noMistakes, set_noMistakes] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  const [questionwithradio, is_questionwithradio] = useState(false);
  const [questionwithtextfield, is_questionwithtextfield] = useState(false);
  const [texttospeechwithtextfield, is_texttospeechwithtextfield] =
    useState(false);
  const [drawquestions, is_drawquestions] = useState(false);
  //const [user_answers, set_user_answers] = useState([]);
  const [user_answers_right, set_user_answers_right] = useState({});
  const [user_answers_right1, set_user_answers_right1] = useState({});
  // const [event_activity_answers, set_event_activity_answers] = useState({});
  const [real_answers, set_real_answers] = useState({});
  const [jwt_token, set_jwt_token] = useState({});
  var passed = false
  var wronganswer = false
  var email = ''

  const [presentquestion, set_presentquestion] = useState({
    answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
    attempts: 0,
    category: 'Sports',
    correctanswer: 'Russia',
    failures: 0,
    id: 0,
    level: 3,
    question: 'Which country hosted 2014 Winter Olympics?',
    specificcategory: 'Olympics',
    subcategory: 'Sports',
  });

  const [playActive] = useSound('../assets/pop.mp3', { volume: 0.25 });

  const [playNext] = useSound('../assets/nextorback.mp3', { volume: 0.25 });

  const [playClock] = useSound('../assets/clock.mp3', { volume: 0.75 });

  const [playPass] = useSound('../assets/pass.mp3', { volume: 0.75 });

  const [playFail] = useSound('../assets/fail.mp3', { volume: 0.75 });

  const { user, setUser } = useContext(UserContext);
  // const {user,setUser} = useContext(UserContext);

  let data1 = useLocation();

  // ////console.log("Calling EventsScreen.....")
  // ////console.log(data1.state)
  // const specificcategory = data1.state["specificcategory"]
  // const level1 = data1.state["level"]
  // const limits = data1["limits"]
  // const eventdisplay = data1["eventdisplay"]
  // ////console.log(specificcategory)
  // ////console.log(level1)
  // ////console.log(limits)
  // ////console.log(eventdisplay)
  let answ = [];

  function playAgainplease() {
    set_score(0);
    set_questionnumber(1);
    set_noquestionsattended(0);
    is_finished(false);
    set_user_answers_right({});
    set_user_answers_right1({});
    set_event_activity_answers({});
    getToken();
    set_real_answers({});
  }

  const getToken = async (id, level, category) => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        set_useremail(user.attributes['email'])

        set_presentquestion({
          answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
          attempts: 0,
          category: 'Sports',
          correctanswer: 'Russia',
          failures: 0,
          id: 0,
          level: 3,
          question: 'Which country hosted 2014 Winter Olympics?',
          specificcategory: 'Olympics',
          subcategory: 'Sports',
        });
        if (user.username.includes("Google_")) {


          set_username(user.attributes['email'])
          set_jwt_token(jwt);
          getQuestionfromDB(jwt, user.attributes['email']);
          //updateEventyActivity(user.attributes['email'],user.attributes['email'],jwt, 0, 'initiated');





        }
        else {
          set_jwt_token(jwt);
          set_username(user.username)
          getQuestionfromDB(jwt, user.username);
          // updateEventyActivity(user.username,user.attributes['email'],jwt, 0, 'initiated');




        }







      });




    } catch (error) {
      // console.log(error)
      Auth.signOut()
    }
  };


  // const getToken = async (id, level, category) => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log(Auth.user.attributes.email)
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();
  //     set_presentquestion({
  //       answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
  //       attempts: 0,
  //       category: 'Sports',
  //       correctanswer: 'Russia',
  //       failures: 0,
  //       id: 0,
  //       level: 3,
  //       question: 'Which country hosted 2014 Winter Olympics?',
  //       specificcategory: 'Olympics',
  //       subcategory: 'Sports',
  //     });
  //     getQuestionfromDB(jwt);
  //     updateEventyActivity(jwt, 0, 'initiated');
  //     set_jwt_token(jwt);
  // };






  const updateEventyActivity = async (jwt, updatedscore, real_answers) => {
    var questionno;
    let eventanswermap = {};
    let wronganswers = [];
    let wronganswercount = 0;

    for (questionno in questionBank) {
      ////console.log(questionno)
      ////console.log(questionBank[questionno].question)
      var question;
      if (imagewithtextfield) {
        question =
          '<img src = ' +
          questionBank[questionno].question +
          ' height: 100px, width: 100px />';
      } else {
        question = questionBank[questionno].question;
      }
      answ[questionno] =
        'Q: ' +
        questionno +
        ' Question: ' +
        question +
        ' Correct Answer: ' +
        questionBank[questionno].correctanswer +
        ' Your selection: ' +
        user_answers_right[questionBank[questionno].id];


      const qid = questionBank[questionno].id;
      const userAnswer = user_answers_right[qid];
      const correctAnswer = real_answers[qid] || null;

      if (userAnswer === undefined || correctAnswer === null) {
        wronganswer = true;
      } else {
        const isCorrect = (correctAnswer == userAnswer || correctAnswer == `Spell ${userAnswer}`);
        if (!isCorrect) wronganswer = true;
      }


      wronganswer = false
      if (userAnswer === undefined) {
        wronganswer = true
      } else {
        const isCorrect = (correctAnswer == userAnswer || correctAnswer == `Spell ${userAnswer}`);
        if (!isCorrect) {
          wronganswer = true;
        }
      }


      if (wronganswer) {
        wronganswers[wronganswercount] = questionBank[questionno];
        wronganswercount = wronganswercount + 1;
      }
      eventanswermap[questionBank[questionno].correctanswer] =
        user_answers_right[questionBank[questionno].id];

    }

    //End of the for loop



    if (wronganswers.length > 0) {
      set_presentquestion(wronganswers[0]);
    }

    set_wrongansweredquestions(wronganswers);

    if (updatedscore >= questionBank.length) {
      passed = true
    }


    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})

      body: JSON.stringify({
        eventid: 123,
        eventname: "notrequired",
        username: username,
        score: updatedscore,
        timetaken: 10,
        targetscore: questionBank.length,
        level: 6,
        passed: passed,
        operation: "practice",
        description: '',
        emailid: email,
        category: data1.state['category'],
        correctanswers: answ,
        eventtype: 'practice',
        qualificationno: questionBank.length,
        emailtobesend: data1.state['sendEmail']
          ? data1.state['sendEmail']
          : false,
        eventemailid: data1.state['email']
          ? data1.state['email']
          : "email",
        useranswers: eventanswermap,
      }),
    };



    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/updatepracticeactivity`,
      requestOptions
    );

    const data = await response.json();


    is_finished(true);



    //set_event_activity_answers(eventanswermap)
  };






  const getQuestionfromDB = async (jwt, username) => {
    const specificcategory = data1.state['specificcategory'];
    const grade = data1.state['grade'];
    const category = data1.state['category'];
    const totalquestions = data1.state['totalquestions'];

    is_imagewithtextfield(false);
    is_imagewithradio(false);
    is_texttospeechwithtextfield(false);
    is_drawquestions(false);
    is_questionwithradio(false);
    is_questionwithtextfield(false);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        category: category,
        name: 'PremiumEvent',
        noofretries: 1,
        points: totalquestions,
        username: username,
        qualificationno: totalquestions,
        subcategory: 'SpellBowl',
        specificcategory: '',
        totalquestions: totalquestions,
        level: grade
      }),
    };

    try {
      const response = await fetch(
        `https://xaoxnzphsh.execute-api.us-east-1.amazonaws.com/dev/quiz/createpremiumquizquestions`,
        requestOptions
      );

      const data = await response.json();

      if (!response.ok) {
        console.error("API Error:", data.message || 'An unknown error occurred');
        is_finished(true); // End the quiz to prevent crash
        return;
      }

      if (data && data.length > 0) {
        const dailyLimit = 20;
        const questionsForToday = data.slice(0, dailyLimit);
        set_questionBank(questionsForToday);
        set_presentquestion(questionsForToday[0]);

        if (data.length > dailyLimit) {
          set_limitReached(true);
          setMotivationMsg(MOTIVATION_COMEBACK);
        } else {
          setMotivationMsg(MOTIVATION_CONTINUE);
        }

        let dict_answer = {};
        for (const question of questionsForToday) {
          dict_answer[question.id] = question.correctanswer;
        }
        set_real_answers(dict_answer);

        const displayformat = questionsForToday[0]['displayformat'];
        if (displayformat === 'ImagewithTextField') {
          is_imagewithtextfield(true);
        } else if (displayformat === 'ImagewithRadio') {
          is_imagewithradio(true);
        } else if (displayformat === 'SpeakTextwithTextField') {
          is_texttospeechwithtextfield(true);
        } else if (displayformat === 'QuestionswithTextField') {
          is_questionwithtextfield(true);
        } else if (displayformat === 'drawquestions') {
          is_drawquestions(true);
        } else {
          is_questionwithradio(true);
        }
      } else {
        // No more mistake words
        set_noMistakes(true);
        is_finished(true);
      }
    } catch (error) {
      console.error("Failed to fetch or parse questions:", error);
      is_finished(true); // End the quiz on critical fetch error
    }
  };

  function computeAnswer(answer, id) {
    if (!id) return;   // prevent crash on last question
    playActive();
    set_user_answers_right((prevAnswers) => ({
      ...prevAnswers,
      [id]: answer,
    }));
  }


  const selectedanswers = () => {
    playNext();
    if (noofquestionsattended + 1 < totalquestions) {
      set_questionnumber(questionnumber + 1);
      set_timerKey(prevKey => prevKey + 1); // Reset timer for next question
      if (noofquestionsattended + 1 < questionBank.length) {
        set_presentquestion(questionBank[noofquestionsattended + 1]);
      } else {
        set_presentquestion(null); // no more questions
      }
      set_user_answers_right((prev) => ({
        ...prev,
        [questionBank[noofquestionsattended + 1].id]: ''
      }));
      var displayformat = questionBank[noofquestionsattended + 1]['displayformat'];
      is_imagewithtextfield(false);
      is_imagewithradio(false);
      is_texttospeechwithtextfield(false);
      is_drawquestions(false);
      is_questionwithradio(false);
      is_questionwithtextfield(false);
      if (displayformat === 'ImagewithTextField') {
        is_imagewithtextfield(true);
      } else if (displayformat === 'ImagewithRadio') {
        is_imagewithradio(true);
      } else if (displayformat === 'SpeakTextwithTextField') {
        is_texttospeechwithtextfield(true);
      } else if (displayformat === 'QuestionswithTextField') {
        is_questionwithtextfield(true);
      } else if (displayformat === 'drawquestions') {
        is_drawquestions(true);
      } else {
        is_questionwithradio(true);
      }

      set_noquestionsattended(noofquestionsattended + 1);
      //////console.log(noofquestionsattended)
    } else {
      //Lets update

      ////console.log("What user selected is ")
      ////console.log(user_answers_right)
      ////console.log("What real answer is  ")
      ////console.log(real_answers)
      let actualScore = 0;
      var key, val;
      for ([key, val] of Object.entries(user_answers_right)) {
        ////console.log(key, val);
        ////console.log(real_answers[key])
        if (real_answers[key] == val || real_answers[key] == 'Spell ' + val) {
          ////console.log("Correct Answer");
          actualScore = actualScore + 1;
          ////console.log(actualScore)

          set_score(actualScore);
          //set_score(10)
        }
      }
      is_finished(true);
      if (
        actualScore >= data1.state['qualificationno'] &&
        data1.state['eventtype'] != 'Assignments'
      ) {
        playPass();
      } else if (data1.state['eventtype'] != 'Assignments') {
        playFail();
      }
      ////console.log("finsihed")
      ////console.log(finished)


      updateEventyActivity(jwt_token, actualScore, real_answers)



      // updateEventyActivity(username,useremail,jwt_token, actualScore, 'ended');
      // setUser(user);
      // console.log('parent', user);
    }

    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  };

  function backanswers() {
    // if(answer == real_answers[id])
    // {
    //   set_score(score + 1)
    // }
    playNext();
    ////////console.log(user_answers)
    //noofquestionsattended = noofquestionsattended + 1
    if (noofquestionsattended > 0) {
      set_questionnumber(questionnumber - 1);
      set_presentquestion(questionBank[noofquestionsattended - 1]);
      // Clear any previously stored answer when going back
      set_user_answers_right((prev) => ({
        ...prev,
        [questionBank[noofquestionsattended - 1].id]: ''
      }));

      set_noquestionsattended(noofquestionsattended - 1);

      is_imagewithtextfield(false);
      is_imagewithradio(false);
      is_texttospeechwithtextfield(false);
      is_drawquestions(false);
      is_questionwithradio(false);
      is_questionwithtextfield(false);

      var displayformat =
        questionBank[noofquestionsattended - 1]['displayformat'];

      if (displayformat == 'ImagewithTextField') {
        is_imagewithtextfield(true);
      } else if (displayformat == 'ImagewithRadio') {
        is_imagewithradio(true);
      } else if (displayformat == 'SpeakTextwithTextField') {
        is_texttospeechwithtextfield(true);
        ////console.log("seetingis_texttospeechwithtextfield(true) ")
      } else if (displayformat == 'QuestionswithTextField') {
        is_questionwithtextfield(true);
      } else if (displayformat == 'drawquestions') {
        is_drawquestions(true);
      } else {
        is_questionwithradio(true);
      }

      //////console.log(noofquestionsattended)
    } else {
      //Lets update
      // is_finished(true)
      // updateEventyActivity(jwt_token)
    }
    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  }

  function handleCallback(childData) {
    let actualScore = 0;
    var key, val;
    for ([key, val] of Object.entries(user_answers_right)) {
      ////console.log(key, val);
      ////console.log(real_answers[key])
      if (real_answers[key] === val || real_answers[key] === 'Spell ' + val) {
        actualScore = actualScore + 1;
        ////console.log(actualScore)

        set_score(actualScore);
        //set_score(10)
      }
    }

    is_finished(childData);
    // updateUserScore(jwt_token, actualScore);
    // updateEventyActivity(jwt_token, actualScore, 'ended');

  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const [questions, setQuestions] = useState([]);
  const [challengeType, setChallengeType] = useState('');
  const [showMotivation, setShowMotivation] = useState(false);
  const [motivationMsg, setMotivationMsg] = useState('');
  const [timer, setTimer] = useState(1200); // 60 seconds per question
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [questionTimerKey, setQuestionTimerKey] = useState(0); // force timer reset

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    let isMounted = true;
    ////console.log("UseEffect calling in QuizApp")
    getToken();
    document.title = 'Quiz';
    // updateEventyActivity(jwt_token, 0);
    //console.log(data1.state['totalquestions'])
    const totalquestions = data1.state['totalquestions'];



    set_totalquestions(totalquestions);
    // console.log("Playing clock")
    playClock();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (['MISTAKESREVIEW', 'HYPHEN_SPACE', 'UPPERCASE'].includes(challengeType)) {
      // Assume props.wrongWords is an array of words the user got wrong
      // Assume props.fillerWords is an array of grade-appropriate filler words
      const maxQuestions = 20;
      let wrongWords = props.wrongWords || [];
      let fillerWords = props.fillerWords || [];
      let selectedQuestions = [];
      let wrongWordsPool = [...wrongWords];
      // Fill as many wrong words as possible, allowing repeats if needed
      while (selectedQuestions.length < maxQuestions && wrongWordsPool.length > 0) {
        selectedQuestions.push(wrongWordsPool.shift());
        // If pool is empty but not enough questions, refill from wrongWords
        if (wrongWordsPool.length === 0 && selectedQuestions.length < maxQuestions && wrongWords.length > 0) {
          wrongWordsPool = [...wrongWords];
        }
      }
      // Fill remaining slots with filler words
      let fillerIdx = 0;
      while (selectedQuestions.length < maxQuestions && fillerIdx < fillerWords.length) {
        selectedQuestions.push(fillerWords[fillerIdx++]);
      }
      setQuestions(selectedQuestions);
      setTimer(60); // Always reset to 60 seconds for first question
      setCurrentQuestion(0);
      // If not all wrong words could be fit today, show comeback message
      if (wrongWords.length > maxQuestions) {
        setShowMotivation(true);
        setMotivationMsg(MOTIVATION_COMEBACK);
      } else if (wrongWords.length > 0 && selectedQuestions.filter(q => wrongWords.includes(q)).length === wrongWords.length) {
        // All mistakes included and can be corrected
        setShowMotivation(true);
        setMotivationMsg(MOTIVATION_CONTINUE);
      } else {
        setShowMotivation(false);
        setMotivationMsg('');
      }
    }
  }, [challengeType, props.wrongWords, props.fillerWords]);

  // Timer effect for each question
  useEffect(() => {
    if (['MISTAKESREVIEW', 'HYPHEN_SPACE', 'UPPERCASE'].includes(challengeType)) {
      if (timer > 0) {
        const interval = setInterval(() => {
          setTimer(prev => prev - 1);
        }, 1000);
        return () => clearInterval(interval);
      } else {
        // Move to next question or end
        if (currentQuestion < questions.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
          setTimer(60); // Always reset to 60 seconds for each new question
        } else {
          // End of review
        }
      }
    }
  }, [timer, challengeType, currentQuestion, questions.length]);

  // TTS logic for microphones (use same as normal quiz)
  const handleTTS = (type) => {
    // type: 1, 2, 3 for the three microphones
    // Use the same logic as practice normal quiz module
    if (['MISTAKESREVIEW', 'HYPHEN_SPACE', 'UPPERCASE'].includes(challengeType)) {
      switch (type) {
        case 1:
          // Speak the word
          window.speechSynthesis.speak(new SpeechSynthesisUtterance(questions[currentQuestion]));
          break;
        case 2:
          // Speak the word in a sentence (if available)
          if (props.sentences && props.sentences[questions[currentQuestion]]) {
            window.speechSynthesis.speak(new SpeechSynthesisUtterance(props.sentences[questions[currentQuestion]]));
          } else {
            window.speechSynthesis.speak(new SpeechSynthesisUtterance(questions[currentQuestion]));
          }
          break;
        case 3:
          // Spell the word
          window.speechSynthesis.speak(new SpeechSynthesisUtterance(questions[currentQuestion].split('').join(' ')));
          break;
        default:
          break;
      }
    }
  };

  // MistakesReview: Per-question timer and correct TTS
  const [mistakeQuestionIndex, setMistakeQuestionIndex] = useState(0);
  const [mistakeTimerKey, setMistakeTimerKey] = useState(0); // force timer reset
  const [finishedMistakes, setFinishedMistakes] = useState(false);

  const currentMistakeQuestion = ['MISTAKESREVIEW', 'HYPHEN_SPACE', 'UPPERCASE'].includes(challengeType) ? questions[mistakeQuestionIndex] : presentquestion;

  const goToNextMistakeQuestion = () => {
    if (mistakeQuestionIndex < questions.length - 1) {
      setMistakeQuestionIndex(mistakeQuestionIndex + 1);
      setMistakeTimerKey(prev => prev + 1); // reset timer
    } else {
      setFinishedMistakes(true);
      is_finished(true);
    }
  };

  const controlButtons = (
    <>
      {presentquestion.id > 0 && finished == false ? (
        <div
          className={
            (questionwithtextfield ||
              texttospeechwithtextfield ||
              imagewithtextfield) &&
            cx(styles.buttonGroup)
          }
        >
          <button key="Back" onClick={backanswers}>
            Back
          </button>
          <button key="Next" onClick={selectedanswers}>
            Next
          </button>
        </div>
      ) : null}
    </>
  );

  return (
    <div>
      {finished &&
        score >= data1.state['qualificationno'] &&
        score === questionBank.length && questionBank.length > 0 && (
          <div className="confetti-container" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9998,
            pointerEvents: 'none',
            overflow: 'hidden'
          }}>
            <Confetti
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 9998
              }}
            />
          </div>
        )}
      <div>
        <div
          className={`${finished ? 'no-shadow inner ' : ''}${cx(
            styles.container
          )}`}
        >
          {/* 
      Show only for Events */}
          {finished &&
            score < data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/icon-sad.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/oops.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                Try Again
              </p>
              <p className={`text-center ${styles.line}`}>
                <span>{data1.state['points']}</span> points deduced from your
                account
              </p>
              <div className={cx(styles.attempt)}>
                You have{' '}
                <span>
                  {data1.state['remainingattempts'] > 0
                    ? data1.state['remainingattempts']
                    : 'no'}
                </span>{' '}
                remaining attempts
              </div>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for Events */}
          {finished &&
            score >= data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/happy.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/congo.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                You cleared the event
              </p>
              <p className={`text-center ${styles.line}`}>
                Your earned <span>{data1.state['points']}</span> points
              </p>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for Assignments */}
          {finished && data1.state['eventtype'] === 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../../assets/images/tick.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} mb-0 text-center`}>
                Thanks
              </div>
              <p className={`text-center color-black ${styles.title}`}>
                Assignment Submitted
              </p>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for all questions */}
          {(presentquestion.id > 0 && (finished === false || questionnumber === questionBank.length)) ? (
            <div className={styles.progress}>
              <CountdownCircleTimer
                key={timerKey}
                isPlaying={!finished}
                duration={60}
                colors={['#eed017']}
                size={105}
                strokeWidth={7}
                onComplete={() => {
                  const result = handleCallback();
                  return [false, result]; // Don't repeat, pass callback result
                }}
              >
                {({ remainingTime }) => {
                  const minutes = Math.floor(remainingTime / 60);
                  const seconds = remainingTime % 60;
                  return (
                    <div className="text-center" style={{ fontSize: '17px' }}>
                      {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      <br />MIN
                    </div>
                  );
                }}
              </CountdownCircleTimer>
              <p className="s-title">time remaining</p>
            </div>
          ) : (
            ' '
          )}

          {noMistakes && (
            <div className="text-center">
              <h2>Congratulations!</h2>
              <p>You have corrected all your mistakes.</p>
            </div>
          )}

          {limitReached && (
            <div className="text-center">
              <h2>Daily limit reached</h2>
              <p>Please come back tomorrow to get the rest of them correct.</p>
            </div>
          )}

          {presentquestion.id > 0 && (finished == false || questionnumber === questionBank.length) && imagewithradio ? (
            <ImagewithRadio
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
            />
          ) : null}

          {presentquestion.id > 0 && (finished == false || questionnumber === questionBank.length) && imagewithtextfield ? (
            <ImagewithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              imageurl={presentquestion.imageurl}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id] || ''}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
              specific_category={presentquestion.specificcategory}
            />
          ) : null}

          {finished && (
            <div>
              <div className={cx(styles.summary)}>
                <div className="item">
                  <p className="s-title">{totalquestions}</p>
                  <p className="sub-title">Question</p>
                </div>
                <div className="item">
                  <p style={{ color: '#2ec32b' }} className="s-title">
                    {score}
                  </p>
                  <p className="sub-title">Correct Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#c32b2b' }} className="s-title">
                    {totalquestions - score}
                  </p>
                  <p className="sub-title">Wrong Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#dd7029' }} className="s-title">
                    {Math.floor((score / totalquestions) * 100)}%
                  </p>
                  <p className="sub-title">Result</p>
                </div>
              </div>
            </div>
          )}

          {presentquestion.id > 0 &&
            (finished == false || questionnumber === questionBank.length) &&
            texttospeechwithtextfield ? (
            <TexttoSpeechwithTextfield
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={`${presentquestion.id}-${questionnumber}`}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id] || ''}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={questionBank.length}
              specific_category={presentquestion.specificcategory}
              meaning={presentquestion.meaning}
              category={presentquestion.category}
              audio={presentquestion.audio}
              word_to_pronounce={presentquestion.correctanswer}
              example={presentquestion.example}
              timerKey={timerKey}
            />
          ) : null}

          {presentquestion.id > 0 &&
            (finished == false || questionnumber === questionBank.length) &&
            questionwithtextfield ? (
            <QuestionswithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id] || ''}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={questionBank.length}
            />
          ) : null}

          {presentquestion.id > 0 && (finished == false || questionnumber === questionBank.length) && questionwithradio ? (
            <NewQuestionBox
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right[presentquestion.id] || ''}
              category={data1.state['subcategory']}
              questionCount={questionBank.length}
              controlButtons={controlButtons}
            />
          ) : null}

          {!questionwithradio && (finished == false || questionnumber === questionBank.length) && controlButtons}

          {presentquestion.id <= 0 ? (
            <div className="welcomecenter">
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
          ) : (
            ''
          )}

          <div className="table-responsive">
            {finished && data1.state['eventtype'] != 'Event' ? (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
              >
                <tr>
                  <th>Question</th>
                  <th>Correct Answer</th>
                  <th>Your Answer</th>
                  <th>Result</th>
                </tr>
              </table>
            ) : (
              ''
            )}

            {finished && (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
                style={{ marginBottom: '30px' }}
              >
                {questionBank.map(
                  ({
                    question,
                    answers,
                    correctanswer,
                    id,
                    id_1,
                    selectedanswer,
                  }) => (
                    <CorrectAnswers
                      question={question}
                      correctanswer={correctanswer !== undefined ? correctanswer : ""}
                      id={id}
                      key={id}
                      alternateanswers={[]} asd
                      selectedanswer={user_answers_right[id] !== undefined ? user_answers_right[id] : ""}
                      eventtype={data1.state['eventdisplay']}
                    />
                  )
                )}
              </table>
            )}
          </div>

          <div className={styles.btnGroup}>
            {finished &&
              score < data1.state['qualificationno'] &&
              data1.state['remainingattempts'] > 0 &&
              (questionwithradio || texttospeechwithtextfield) ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/events',
                    state: { category: data1.state['category'] },
                  }}
                >
                  <button className={cx(button)}> Play Again </button>
                </Link>
              </div>
            ) : (
              ''
            )}

            {finished && data1.state['eventtype'] != 'Assignments' ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/premiumevents',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}> Try Again </button>
                </Link>
              </div>
            ) : (
              ''
            )}

            {finished && data1.state['eventtype'] == 'Assignments' ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/premiumevents',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}> Next Event </button>
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PremiumQuiz;
